import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Apollo } from 'apollo-angular';
import { AdditionalTaskItemApiService } from '../additional-task-item-api.service';
import { IAdditionalTaskItem } from '../../../models/additionalTaskItem.interface';
import { ListAdditionalTaskItemQuery } from '../../../graphql/queries/additional-task-item.query';

@Injectable({
  providedIn: 'root'
})
export class AdditionalTaskItemGqlService
  implements AdditionalTaskItemApiService {
  constructor(private apollo: Apollo) {}

  public getList(): Observable<IAdditionalTaskItem[]> {
    return this.apollo
      .query({
        query: ListAdditionalTaskItemQuery,
        fetchPolicy: 'network-only'
      })
      .pipe(
        map(result => {
          const returnHelps = result.data['additionalTaskItems'] as IAdditionalTaskItem[];

          return returnHelps;
        }),
        take(1)
      );
  }
}
